import { render, staticRenderFns } from "./StockIcon.vue?vue&type=template&id=97651c14"
import script from "./StockIcon.vue?vue&type=script&lang=js"
export * from "./StockIcon.vue?vue&type=script&lang=js"
import style0 from "./StockIcon.vue?vue&type=style&index=0&id=97651c14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports